"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  uniqueId: 1,
  root: "/mia",
  name: "mia",
  abbr: "MIA",
  title: "Museene i Akershus",
  imageUrl: "https://dms-cf-09.dimu.org/image/032yiziWuETr",
  theme: {
    primaryColor: "#003d4c"
  },
  apps: [{
    icon: "m24",
    layout: "finder",
    ownerId: 1,
    url: "/mia/m24/",
    title: "Museum24"
  }, {
    icon: "dm",
    layout: "finder",
    ownerId: 1,
    url: "/mia/dm/",
    title: "DigitaltMuseum"
  }, {
    icon: "kp",
    layout: "finder",
    ownerId: 1,
    url: "/mia/kp/",
    title: "KulturPunkt"
  }]
};
exports.default = _default;
module.exports = exports.default;